// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PLineHeightOutlinedSvg from "@fishx/icons-svg/es/asn/PLineHeightOutlined";
import FishxIcon from '../components/FishxIcon';

var PLineHeightOutlined = function PLineHeightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PLineHeightOutlinedSvg
  }));
};

PLineHeightOutlined.displayName = 'PLineHeightOutlined';
export default React.forwardRef(PLineHeightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PLineHeightOutlined.js
// module id = 3485
// module chunks = 0